/**
 * Redux listener middleware setup.
 *
 * Handles side-effects that are triggered by Redux actions,
 * keeping components free of data-fetching useEffect hooks.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createListenerMiddleware, addListener } from '@reduxjs/toolkit';
import { fetchPatientTabs } from './tabs/tabsSlice';
import { fetchTimeline } from './timeline/timelineSlice';
export const listenerMiddleware = createListenerMiddleware();
export const startAppListening = listenerMiddleware.startListening.withTypes();
export const addAppListener = addListener.withTypes();
// Fetch timeline only when tabs confirm an order exists (status tab present)
startAppListening({
    actionCreator: fetchPatientTabs.fulfilled,
    effect: (_action, listenerApi) => __awaiter(void 0, void 0, void 0, function* () {
        const state = listenerApi.getState();
        const hasStatusTab = state.tabs.tabs.some((tab) => tab.name === 'status');
        const patientId = state.smart.patientId;
        if (hasStatusTab && patientId) {
            listenerApi.dispatch(fetchTimeline(patientId));
        }
    })
});
